import { render, staticRenderFns } from "./ControlsPauseIcon.vue?vue&type=template&id=0e4a587e&scoped=true&"
import script from "./ControlsPauseIcon.vue?vue&type=script&lang=js&"
export * from "./ControlsPauseIcon.vue?vue&type=script&lang=js&"
import style0 from "./ControlsPauseIcon.vue?vue&type=style&index=0&id=0e4a587e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4a587e",
  null
  
)

export default component.exports